import AboutVerifiedCard from "@/icons/verification-card-vector";

const VerificationCard = () => {
	return (
		<div className="mt-8 rounded-lg p-6 shadow-xl shadow-brand-primary/5">
			<div className="mb-4 ml-auto w-40">
				<AboutVerifiedCard className="h-full w-full" />
			</div>

			<h4 className="mb-2 text-xl font-semibold tracking-tight md:text-2xl">
				We represent here more than just a{" "}
				<span className="text-brand-primary">Professional Proptech Space.</span>
			</h4>

			<p className="text-sm text-gray-500 md:text-base">
				We adhere to the values of a true community where we focus on uplifting others by being
				helpful - be it a fellow founder or any professional in proptech
			</p>
		</div>
	);
};

export default VerificationCard;
